import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { projectsKeys } from '@core/react-query/features/projects'

export const useRemoveProjectsFromChecklistTemplate = (
  options?: UseMutationOptions<
    unknown,
    string,
    RequestTypes['removeProjectsFromTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.removeProjectsFromTemplate,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries(projectsKeys._def)
    },
  })
}
